export default "/images/0d71e6966c11f94d1fd3b7c87883d5e2.avif";